module.exports = __webpack_public_path__ + "static/media/popup-warn.356fd863.svg";